import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image'

const Biseccion=({img,title,paragraph})=>{
  return  <Container>
            <Row>
              <Col  className="text-center"  xs={12} md={2}>

              </Col>
              <Col  className="text-center"  xs={12} md={5}>
                <Image src={img} fluid/>
              </Col>
              <Col  className="text-center"  xs={12} md={4}>
                <div className={paragraph.className}>{paragraph.label}</div>
                <div className={title.className}>{title.label}</div>
                <ul className="text-start">
                  <li>Sillas cómodas</li>
                  <li>Video Beam</li>
                  <li>Telón</li>
                  <li>Sonido</li>
                  <li>Tablero</li>
                  <li>Acrílico</li>

                  <li>Wifi</li>
                  <li>Estación de Café </li>
                  <li>Convenio con la cafetería para refrigerios</li>
                  <li>Convenio con banquetes para almuerzos</li>
                  <li>Cena Bufet</li>
                  <li>Aire acondicionado</li>
                </ul>
              </Col>
              <Col  className="text-center"  xs={12} md={1}>

              </Col>
            </Row>
          </Container>
}

export default Biseccion
